export default __webpack_public_path__ + "src/images/controller_play-a8d6d2.png";